// TODO REPL-24674 (Berkley, 2026-03-04): Move this to AI generated
type PromptSuggestion = {
  prompt: string;
  aliases?: string;
};

const PROMPT_SUGGESTIONS: PromptSuggestion[] = [
  {
    prompt: "landing page for BFCM",
    aliases: "black friday sale promo campaign holiday",
  },
  {
    prompt: "product launch landing page",
    aliases: "new release drop announce",
  },
  {
    prompt: "seasonal campaign landing page",
    aliases: "summer winter spring fall holiday",
  },
  {
    prompt: "flash sale landing page with countdown timer",
    aliases: "limited time urgent",
  },
  {
    prompt: "holiday gift guide landing page",
    aliases: "valentine occasion mothers fathers",
  },
  {
    prompt: "influencer collaboration landing page",
    aliases: "collab creator partner",
  },
  {
    prompt: "pre-launch waitlist landing page",
    aliases: "prelaunch coming soon early",
  },
  {
    prompt: "advertorial-style landing page",
    aliases: "editorial native ad sponsored",
  },
  {
    prompt: "product quiz landing page with personalized results",
    aliases: "recommendation finder match",
  },
  {
    prompt: "email capture landing page with lead magnet",
    aliases: "opt signup newsletter",
  },
  {
    prompt: "webinar registration landing page",
    aliases: "event virtual live",
  },
  { prompt: "giveaway contest landing page", aliases: "sweepstakes win enter" },
  {
    prompt: "product page optimized for subscriptions",
    aliases: "recurring pdp detail shop subscribe",
  },
  {
    prompt: "product bundle page with savings breakdown",
    aliases: "kit set combo pack value",
  },
  {
    prompt: "limited edition product drop page",
    aliases: "exclusive rare special",
  },
  {
    prompt: "product comparison page with feature matrix",
    aliases: "compare vs versus alternative",
  },
  {
    prompt: "before & after product results page",
    aliases: "transformation proof",
  },
  {
    prompt: "product ingredients and science breakdown page",
    aliases: "material formula",
  },
  {
    prompt: "product page with upsell and cross-sell sections",
    aliases: "addon add-on complement",
  },
  {
    prompt: "product page with video demo and how-to guide",
    aliases: "tutorial",
  },
  {
    prompt: "customizable product page with live preview",
    aliases: "personalize engrave monogram build",
  },
  {
    prompt: "collection page with filterable product grid",
    aliases: "category catalog browse shop all",
  },
  {
    prompt: "bestsellers collection page with social proof",
    aliases: "best seller popular top trending",
  },
  {
    prompt: "new arrivals collection page",
    aliases: "latest fresh just dropped",
  },
  {
    prompt: "sale and clearance collection page",
    aliases: "discount markdown outlet",
  },
  {
    prompt: "homepage with hero section and featured products",
    aliases: "home main welcome",
  },
  {
    prompt: "about us page with brand story and team section",
    aliases: "company mission who",
  },
  {
    prompt: "sustainability and brand values page",
    aliases: "eco green impact ethical responsible",
  },
  {
    prompt: "press and media mentions page",
    aliases: "news feature coverage mention as seen",
  },
  {
    prompt: "customer reviews and testimonials page",
    aliases: "rating star feedback social",
  },
  {
    prompt: "UGC gallery page with shoppable customer photos",
    aliases: "user generated content community",
  },
  {
    prompt: "customer success story page",
    aliases: "case study result outcome client",
  },
  {
    prompt: "unboxing experience showcase page",
    aliases: "first impression reveal haul",
  },
  {
    prompt: "referral program page with reward tiers",
    aliases: "refer friend invite share earn",
  },
  {
    prompt: "loyalty and rewards program page",
    aliases: "points vip member membership perks",
  },
  {
    prompt: "post-purchase thank you page with upsell",
    aliases: "confirmation order",
  },
  {
    prompt: "cart recovery landing page with special offer",
    aliases: "abandon win back return save",
  },
  {
    prompt: "subscription reorder and replenishment page",
    aliases: "replenish restock auto refill",
  },
  {
    prompt: "5 reasons why listicle page",
    aliases: "list blog article content post",
  },
  {
    prompt: "blog post page with inline product callouts",
    aliases: "article content read story editorial",
  },
  {
    prompt: "how-to guide page with step-by-step instructions",
    aliases: "tutorial learn tips 101 beginner",
  },
  {
    prompt: "lookbook page with shoppable editorial layout",
    aliases: "visual style mood inspiration",
  },
  {
    prompt: "routine or recipe page with shoppable steps",
    aliases: "regimen ritual protocol",
  },

  // Support & info
  {
    prompt: "FAQ page with expandable sections",
    aliases: "question help support answer",
  },
  { prompt: "contact page with inquiry form", aliases: "reach email touch" },
  {
    prompt: "shipping and returns policy page",
    aliases: "delivery refund exchange",
  },
  {
    prompt: "size guide page with interactive fit finder",
    aliases: "chart measure dimension",
  },
  {
    prompt: "order tracking page with shipment status",
    aliases: "track delivery where",
  },
  { prompt: "pricing page with comparison table", aliases: "plan tier cost" },
  {
    prompt: "wholesale pricing and B2B inquiry page",
    aliases: "bulk business volume trade",
  },
  {
    prompt: "gift card purchase page with custom amounts",
    aliases: "voucher certificate present give",
  },
  {
    prompt: "store locator page with interactive map",
    aliases: "find near location retail",
  },
  {
    prompt: "affiliate and ambassador program page",
    aliases: "partner earn commission",
  },
  {
    prompt: "coming soon teaser page with email signup",
    aliases: "sneak peek preview announce",
  },
  {
    prompt: "free sample or trial offer page",
    aliases: "try mini starter discovery",
  },
];

const DEFAULT_PROMPTS = new Set([
  "landing page for BFCM",
  "product page optimized for subscriptions",
  "homepage with hero section and featured products",
]);

export function getRelevantSuggestions({
  query,
  maxCount = 3,
}: {
  query: string;
  maxCount?: number;
}): PromptSuggestion[] {
  const lowerQuery = query.toLowerCase().trim();
  if (!lowerQuery) {
    return [];
  }

  const strippedQuery = lowerQuery
    .replace(
      /^(build\s+me\s+(an?\s+)?|create\s+(an?\s+)?|make\s+(an?\s+)?|design\s+(an?\s+)?)/,
      "",
    )
    .trim();

  const queryWords = (strippedQuery || lowerQuery)
    .split(/\s+/)
    .filter((w) => w.length >= 2);

  const scored = PROMPT_SUGGESTIONS.map((suggestion) => {
    let score = 0;
    const lowerPrompt = suggestion.prompt.toLowerCase();
    const fullPrompt = `build me a ${lowerPrompt}`;
    const searchableText = suggestion.aliases
      ? `${lowerPrompt} ${suggestion.aliases}`
      : lowerPrompt;

    if (fullPrompt.startsWith(lowerQuery)) {
      score += 5;
    }

    if (strippedQuery && lowerPrompt.includes(strippedQuery)) {
      score += 4;
    }

    for (const word of queryWords) {
      if (searchableText.split(/\s+/).some((term) => term.startsWith(word))) {
        score += 3;
      }
      if (lowerPrompt.includes(word)) {
        score += 2;
      }
    }

    return { ...suggestion, score };
  });

  const matches = scored
    .filter((s) => s.score > 0)
    .sort((a, b) => b.score - a.score);

  if (matches.length > 0) {
    return matches.slice(0, maxCount);
  }

  return PROMPT_SUGGESTIONS.filter((s) => {
    return DEFAULT_PROMPTS.has(s.prompt);
  }).slice(0, maxCount);
}
